const enCommonWords = {
  yes: 'Yes',
  no: 'No',
  contracts: ''
};

export default enCommonWords;
